import type { Technique } from '../types';
import { PHYSARUM_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type PhysarumState } from './render';

export const physarum: Technique<PhysarumState> = {
  id: 'physarum',
  name: 'Physarum / Schleimpilz',
  category: 'growth',
  description: 'Agenten legen Pheromonspuren und bilden Transportnetze um den Text — oder durch ihn hindurch.',
  params: PHYSARUM_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
